import { createContext } from 'react';
import { TenjinSettingsRequest } from './types';

export type GenerateResponseContextValue = {
  settings: TenjinSettingsRequest | undefined;
  setSettings: React.Dispatch<React.SetStateAction<TenjinSettingsRequest | undefined>>;
};

export const GenerateResponseContext = createContext<GenerateResponseContextValue | null>(null);
GenerateResponseContext.displayName = 'GenerateResponseContext';
